module.exports = __webpack_public_path__ + "img/avatar-44.4393def6.png";